import { Component, OnInit} from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { VariablesService } from '../../services/variables.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  templateUrl: './agreements.component.html'
})
export class AgreementsComponent implements OnInit {
  isSubmitting: boolean;
  attendee: any;
  enrollment: any;
  emailFormArray: Array<any> = [];
  otherChecked: boolean;
  varCancelPolicy;
  varTravelPolicy;
  varTrack;
  varCodeOfConduct;
  isFormCompleted=false;
  isRegComplete;
  varPACAck;
  // varAssumRisk;

  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private variablesService: VariablesService,
    public modalService: ModalService

  ) {
    this.attendee = this.registrationService.getAttendee({});
    this.enrollment = this.registrationService.getEnrollment({});
    this.isRegComplete = this.registrationService.isRegistrationComplete();

    this.varCancelPolicy = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varCancelPolicy.ID,
      {}
    );

    this.varTravelPolicy = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varTravelPolicy.ID,
      {}
    );
    this.varTrack = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varTrack.ID,
      {}
    );
    this.varCodeOfConduct = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varCodeOfConduct.ID,
      {}
    );
    // this.varAssumRisk = this.registrationService.getVariable(
    //   this.attendee,
    //   this.variablesService.VARIABLE.varAssumRisk.ID,
    //   {}
    // );
    this.varPACAck = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varPACAck.ID,
      {}
    );

    if ( this.varCancelPolicy.Value === "Agreed") {
      this.enrollment.$mtccancelpolicy = true;
    }

    if (this.varTravelPolicy.Value === "Agreed") {
      this.enrollment.$mtctravelpolicy = true
     }
 
     if (this.varCodeOfConduct.Value === "Agreed" ) {
       this.enrollment.$mtccodeofconduct = true;
     }
 
     if ( this.varPACAck.Value === "Agreed") {
       this.enrollment.$mtcpacack = true;
     }
 


  }
  ngOnInit(): void { }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }

  openModalExternal(url, title, actionButtonText) {
    this.modalService.openModalExternal(url, title, actionButtonText);
  }

  /**
   * @function back
   * @description Uses [navigation.service.back()] to go back to previous page.
   */
  back() {
    this.navigationService.back();
  }

  /**
   * @function forward
   * @description Checks if form is valid then uses [navigation.service.forward()] to go forward to next page.
   */
  forward(form) {
    this.isFormCompleted=true;
    if (form.valid) {

      if (this.enrollment.$mtctravelpolicy === true) {
        this.varTravelPolicy.Value = "Agreed";
      }
  
      if (this.enrollment.$mtccodeofconduct === true) {
        this.varCodeOfConduct.Value = "Agreed";
      }

  
      if (this.enrollment.$mtcpacack === true) {
        this.varPACAck.Value = "Agreed";
      }
      if (this.enrollment.$mtccancelpolicy === true) {
        this.varCancelPolicy.Value = "Agreed";
      }


      if (this.enrollment.AgreedToTermsAndConditions) {
        this.enrollment.ResponsibilityStatement = true;
      }
    this.isSubmitting = true;
    this.navigationService.forward();
    }
  }
}
